export default __webpack_public_path__ + "static/media/G3LS_150.ece185a9.jpg";